import { Image } from 'antd';
import home_banner from "../../assets/img/home_banner_logo.jpg";

const HomeBanner = (props) => {
  const { variant, extra, children, ...rest } = props;
  return (
    <div
      className={`overflow-hidden max-w-[600px] my-5 !z-5 relative flex flex-col rounded-[20px] bg-white bg-clip-border shadow-3xl shadow-shadow-500 dark:!bg-intsamis-800 dark:text-white dark:shadow-none ${extra}`}
      {...rest}
    >
      <Image width="100%" src={home_banner} preview={false}/>
    </div>
  );
}

export default HomeBanner;
